import { useState, useEffect } from 'react'
import { List, ListItem, Link } from '@chakra-ui/react'

const NoticeList = ({ restore }) => {
  const [day, setDay] = useState(null)

  useEffect(() => {
    const today = new Date()
    setDay(today.getDate())
  }, [])

  return (
    <List pl={8} pr={4} fontSize="xs">
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        本コースは定期購入（自動継続）です。
      </ListItem>
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        次回以降の決済日は毎月{day}日です。ただし、該当日がない月は月末最終日に自動決済されます。
        <br />
        （例：5月31日に登録した場合、6月は30日に決済されます。）
      </ListItem>
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        次回以降のコインと継続ボーナスポイントは、自動決済日の翌日に付与されます。
      </ListItem>
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        月額登録の解除は、<Link href="/user/monthly_course_unregister">月額解除ページ</Link>からコースごとに行ってください。
      </ListItem>
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        コインは購入日を起算日として180日目まで有効です。
      </ListItem>
      <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
        ボーナスポイントは付与日を起算日として30日目まで有効です。
      </ListItem>

      {restore && (
        <ListItem position="relative" _before={{ content: '"•"', position: 'absolute', left: '-1.2em' }}>
          決済エラー（クレジットカードの有効期限切れ、限度額超過等）の理由は、大変お手数ですがカード発行会社または契約している携帯電話会社へお問い合わせください。
        </ListItem>
      )}
    </List>
  )
}

export default NoticeList
